import React, { useEffect, useState } from "react";

interface HeadlineProps {
  className?: string;
}

const Headline: React.FC<HeadlineProps> = ({ className }) => {
  const [localDate, setLocalDate] = useState<string>("");
  const [headline, setHeadline] = useState<string>("");

  const generateHeadline = (): string => {
    const headlines = [
      "L'incertitude, c'est notre spécialité",
      "Pour ceux qui aiment les surprises",
      "Votre dose quotidienne d'imprévisibilité",
      "Nous devinons, vous décidez !",
      "La météo : un art, pas une science !",
      "Pour des aventures sans air plein d'imprévus",
      "Nos experts prévoient des averses d'absurdités tout au long de la journée",
      "80% de chances de pluie; 100% de chances de confusion",
      "Un soleil radieux, mais seulement chez votre voisin.",
      "De la météo 'plutôt bien', ce qui veut dire 'attroce'",
      "Nos astrologues se prononcent...",
      "Un temps merveilleux pour les personnes qui ne sortent pas",
      "Des prévisions 'acceptables' si vous ne regardez pas dehors",
      "Pour des averses de doutes et de questionnements",
      "Préparez-vous à des averses de sarcasme et de scepticisme",
    ];

    const randomIndex = Math.floor(Math.random() * headlines.length);
    return headlines[randomIndex];
  };

  useEffect(() => {
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      month: "long",
      day: "numeric",
    };
    const formattedDate = date.toLocaleDateString("fr-CA", options);

    const capitalizedDate =
      formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    setLocalDate(capitalizedDate);

    setHeadline(generateHeadline());
  }, []); // The empty array means no dependencies... the headline will only be set once

  return (
    <div className={className}>
      <h2 className="text-xl sm:text-2xl">
        <div>Nous sommes le {localDate}</div>
      </h2>
      <h1 className="py-6 text-4xl sm:text-6xl">{headline}</h1>
    </div>
  );
};

export default Headline;
